module.exports = __webpack_public_path__ + "img/charging-station-hyper-fast-desktop.4b91d859.png";